import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";

const Authmiddleware = ({ children }) => {
  const location = useLocation();

  const token = Cookies.get("access_token");

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default Authmiddleware;
